import api from './api';

const url = 'projecttype';

const findAll = () => api.get(`${url}/read-projecttype`);

export default { findAll };
